var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-cascader',{attrs:{"filterable":"","options":_vm.organizationList,"props":{
    expandTrigger: 'hover',
    label: 'name',
    value: 'id',
    children: 'childs',
    checkStrictly: true,
  },"placeholder":_vm.$t('message.scopeOfPersonnel'),"clearable":""},on:{"change":_vm.getAdmin},model:{value:(_vm.orgId),callback:function ($$v) {_vm.orgId=$$v},expression:"orgId"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }